module.exports = __webpack_public_path__ + "static/media/benefit_2.2bfdb850.svg";